
export const BOARDS_TOPIC_ROOT = 'TaskBoards'
export const TOPIC_USING_BOARDS = `${BOARDS_TOPIC_ROOT}/UsingDaptivTaskBoards.htm`
export const TOPIC_CUSTOM_BOARDS = `${BOARDS_TOPIC_ROOT}/CustomTaskBoards.htm`



// WEBPACK FOOTER //
// ./src/constants/boardsHelpTopics.js